import PropTypes from "prop-types";
import Button from "components/ui/Button/Button";
import UserDetail from "components/ui/UserDetail/UserDetail";
import { useDialog } from "context/DialogContext";
import GroupMemberRemoveDialog from "features/groups/components/GroupMemberRemoveDialog";
import GroupMemberAcceptDenyDialog from "features/groups/components/GroupMemberAcceptDenyDialog";
import "features/groups/assets/styles/GroupMember.scss";

const GroupMember = ({ id, profile, status, motivation, isAdmin, showAccessControls = false, onUpdated }) => {
  const { showDialog } = useDialog();

  const onAcceptDeny = () => {
    const denyDialog = (
      <GroupMemberAcceptDenyDialog groupMemberId={ id }
                                   motivation={ motivation }
                                   onCompleted={ onUpdated }
                                   name={ profile?.title?.value }/>
    );
    showDialog(denyDialog);
  }

  const onRemove = () => {
    const removeDialog = <GroupMemberRemoveDialog groupMemberId={ id }
                                                  name={ profile?.title?.value }
                                                  onCompleted={ onUpdated }/>;
    showDialog(removeDialog);
  }

  let accessControlButtons = [];
  switch (status) {
    case 'access_requested':
      accessControlButtons.push(<Button variant={ `ghost` } onClick={ onAcceptDeny }>Accepteren of weigeren</Button>);
      break;

    case 'is_member':
      accessControlButtons.push(<Button variant={ `ghost-danger` } onClick={ onRemove }>Verwijderen</Button>);
      break;

    default:
      return null;
  }

  return (
    <div
      className={ `group-member group-member--${ status } group-member--${ isAdmin && 'admin' } wrapper--margin-small` }>
      <UserDetail username={ profile?.title?.value }
                  image={ profile?.field_profile_photo?.value }
                  subtext={ `${ profile?.field_profile_city?.value || `` } ${ isAdmin ? '(Beheerder)' : '' }` }
                  url={ profile?.url }/>
      {
        showAccessControls && !isAdmin &&
        <div>
          { accessControlButtons }
        </div>
      }
    </div>
  );
}

GroupMember.propTypes = {
  id: PropTypes.number.isRequired,
  profile: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  motivation: PropTypes.string,
  isAdmin: PropTypes.bool.isRequired,
  showAccessControls: PropTypes.bool.isRequired
}

export default GroupMember;
